import { useEffect } from 'react';
import { SignIn, SignUp, SignedOut, SignedIn } from '@clerk/clerk-react';
import { useLocation, Link } from '@tanstack/react-router';
import { Button } from '../../components/ui/button';

export function AuthenticationPage() {
    const location = useLocation();

    const isSignInPage = location.pathname.startsWith('/sign-in');
    const isSignUpPage = location.pathname.startsWith('/sign-up');

    useEffect(() => {
        document.title = `${isSignInPage ? 'Sign In' : 'Sign Up'} | Zindua LMS`;
    }, [isSignInPage]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-white dark:bg-[#212126]">
            <SignedOut>
                {isSignInPage && <SignIn routing="path" path="/sign-in" />}
                {isSignUpPage && <SignUp routing="path" path="/sign-up" />}
            </SignedOut>
            <SignedIn>
                <div className="flex flex-col items-center justify-center bg-neutral-50">
                    <img src="/undraw_right-direction.svg" alt="Already signed in" className="w-1/2 max-w-75" />
                    <h1 className="text-[16px] md:text-[20px] font-bold text-neutral-950 mt-8 text-center">
                        You are already signed in
                    </h1>
                    <Link to="/dashboard" preload="intent" preloadDelay={0}>
                        <Button variant="destructive" className="mt-6 capitalize px-8">
                            Go to Dashboard
                        </Button>
                    </Link>
                </div>
            </SignedIn>
        </div>
    );
}
